import { useEffect } from 'react';

import type { THeaderObj } from './page-header-context';
import { usePageContext } from './use-page-header';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const useSetHeader = (header: THeaderObj = {}, dependency?: any) => {
  const { setHeader } = usePageContext();

  useEffect(() => {
    setHeader(header);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, dependency ?? []);
};
